<div class="course-publish">
  <div class="course-publish__content">
    <div class="course-publish__container">
      <div class="course-publish__section">
        <app-course-info-card [course]="selectedCourse()" />
        <app-course-description-card [course]="selectedCourse()" />
        <app-lessons-list
          [layoutVariant]="layoutVariant()"
          [course]="selectedCourse()"
          [tasks]="tasks()"
        />
      </div>
    </div>
  </div>
  <app-cta-button variant="light" size="small" [disabled]="isPublishing()" [loading]="isPublishing()" (clicked)="onComplete()">
    <span cta-prefix>
      <img src="public/svgs/ai-w.svg" alt="AI" />
    </span>
    <span cta-label>{{ 'app.components.courseCreator.publish.publish' | translate }}</span>
  </app-cta-button>
</div>